import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getCookie, setCookie } from './lib/cookie-utils';
import en from './locales/en/translation.json';
import ja from './locales/ja/translation.json';
import de from './locales/de/translation.json';
import fr from './locales/fr/translation.json';
import es from './locales/es/translation.json';

export const LANGUAGE_COOKIE = 'folge_lang';

export const supportedLanguages = [
  { code: 'en', label: 'English' },
  { code: 'de', label: 'Deutsch' },
  { code: 'fr', label: 'Français' },
  { code: 'es', label: 'Español' },
  { code: 'ja', label: '日本語' },
] as const;

const savedLang = getCookie(LANGUAGE_COOKIE);

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    ja: { translation: ja },
    de: { translation: de },
    fr: { translation: fr },
    es: { translation: es },
  },
  lng: savedLang || 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

i18n.on('languageChanged', (lng) => {
  setCookie(LANGUAGE_COOKIE, lng, { maxAge: 365 * 24 * 60 * 60 });
});

export default i18n;
